import React from 'react'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'
import Img from 'gatsby-image'

const FluidImages = ({ image, className }) => (
  <Img
    fluid={image.imageFile.fluid}
    alt={image.altText}
    title={image.imageTitle}
    className={className}
  />
)

FluidImages.propTypes = {
  image: PropTypes.shape({
    imageTitle: PropTypes.string.isRequired,
    altText: PropTypes.string.isRequired,
    imageFile: PropTypes.shape({
      fluid: PropTypes.object.isRequired,
    }).isRequired,
  }).isRequired,
  className: PropTypes.string,
}

FluidImages.defaultProps = {
  className: '',
}

export default FluidImages

export const FluidImageFragment = graphql`
  fragment FluidImageFragment on ContentfulImage {
    imageTitle
    altText
    imageFile {
      fluid(maxWidth: 2000) {
        ...GatsbyContentfulFluid
      }
    }
    mobileImageFile {
      fluid(maxWidth: 700) {
        ...GatsbyContentfulFluid
      }
    }
  }
`
